<template>
  <base-widget
    ref="widget"
    :title="$t('notifications.title')"
    condensed
    :style="heightStyles"
    :scrollable="items && items.length !== 0"
    :loading="loading"
  >
    <template slot="right">
      <base-link-with-icon
        v-if="readonly"
        @click="openEditor()"
      >
        {{ responsive.xl ? $t('notifications.new') : $t('common.new') }}
      </base-link-with-icon>
    </template>
    <template slot="after-heading">
      <notification-editor
        v-if="editor && !isIPad"
        :emojis="true"
        :attachments="true"
        @cancel="editor = false"
        @post="post"
      />
    </template>
    <template slot="loading">
      <base-skeleton
        v-for="n in 3"
        :key="n"
        :opacity="0 + (1 /n)"
      >
        <div class="d-flex mb-2">
          <div class="skeleton__item" />
          <div
            class="skeleton__item mt-0 ml-2"
            style="max-width: 30px"
          />
        </div>
        <div class="skeleton__item" />
        <div class="skeleton__item" />
      </base-skeleton>
    </template>

    <template v-if="items.length === 0 && !loading">
      <empty
        title="No messages yet"
        subtitle="Here you will see comunications and alerts"
      />
    </template>

    <notification-list
      v-if="!loading"
      :items="items"
      @delete-item="onDeleteItem"
    />
    <notification-edit-modal
      :show="editor && isIPad"
      :emojis="true"
      :attachments="true"
      @cancel="editor=false"
      @post="post"
    />
  </base-widget>
</template>

<script>
import minHeightMixin from '@/components/mixins/minheight';
import whichbrowser from '@/components/mixins/whichbrowser';
import responsive from '@/components/mixins/responsive';
import NotificationEditor from './Notifications/NotificationEditor';
import NotificationList from './Notifications/NotificationList';

export default {
  components: {
    NotificationList,
    NotificationEditor,
  },
  mixins: [minHeightMixin, whichbrowser, responsive],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    editor: false,
  }),
  methods: {
    post(evt) {
      this.$emit('post', evt);
      this.editor = false;
    },
    onDeleteItem(notificationPk) {
      this.$emit('delete-item', notificationPk);
    },
    openEditor() {
      this.editor = true;
      this.$mixpanel.track('new_notification', {
        account_id: this.$store.state.account.user.user.email,
      });
    },
  },
};
</script>
